<template>
    <div class="login">
        <el-row type="flex" justify="center">
            <el-col class="is-text-align-center logobox">
                <svg-icon icon-class="logo" />
                <h1 v-html="options['login_titre']" />
            </el-col>
        </el-row>
        <el-row class="is-text-align-center">
            <el-col>
                <el-form
                    ref="loginForm"
                    :model="loginForm"
                    :rules="loginRules"
                    class="login-form"
                    auto-complete="on"
                    label-position="left"
                >
                    <el-form-item prop="email">
                        <el-input
                            v-model="loginForm.email"
                            name="email"
                            type="text"
                            auto-complete="on"
                            placeholder="Email"
                            prefix-icon="el-icon-user"
                        />
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input
                            v-model="loginForm.password"
                            :type="pwdType"
                            name="password"
                            auto-complete="off"
                            placeholder="Password"
                            prefix-icon="el-icon-lock"
                            @keyup.enter.native="handleLogin"
                        />
                    </el-form-item>
                    <el-form-item>
                        <el-button
                            :loading="loading"
                            type="success"
                            @click.native.prevent="handleLogin"
                        >
                            Connexion
                        </el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button
                            type="warning"
                            class="button"
                            @click.native.prevent="$router.push(`/inscription`)"
                            v-html="options['login_boutoninscription']"
                        />
                    </el-form-item>
                    <el-link href="/password/reset">
                        mot de passe oublié
                    </el-link>
                </el-form>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import { validEmail } from "@/utils/validate";
import { findoptions } from "@/utils/options";

export default {
    name: "login",
    data() {
        const validateEmail = (rule, value, callback) => {
            if (!validEmail(value)) {
                callback(new Error("L’Email n’est pas correct"));
            } else {
                callback();
            }
        };
        const validatePass = (rule, value, callback) => {
            if (value.length < 4) {
                callback(new Error("Le mot de passe doit être sup. à 4"));
            } else {
                callback();
            }
        };
        return {
            loginForm: {
                email: "",
                password: ""
            },
            loginRules: {
                email: [
                    {
                        required: true,
                        trigger: "blur",
                        validator: validateEmail
                    }
                ],
                password: [
                    {
                        required: true,
                        trigger: "blur",
                        validator: validatePass
                    }
                ]
            },
            loading: false,
            pwdType: "password",
            redirect: undefined,
            options: {
                login_titre: "DPR",
                login_boutoninscription: "inscription",
                login_intro: ""
            }
        };
    },
    watch: {
        $route: {
            handler: function(route) {
                this.redirect = route.query && route.query.redirect;
            },
            immediate: true
        }
    },
    created() {
        findoptions(this.options, this);
    },
    methods: {
        callbackoptions(slug, data) {
            this.options[slug] = data;
        },
        showPwd() {
            if (this.pwdType === "password") {
                this.pwdType = "";
            } else {
                this.pwdType = "password";
            }
        },
        handleLogin() {
            this.$refs.loginForm.validate(valid => {
                if (valid) {
                    this.loading = true;
                    this.$store
                        .dispatch("user/login", this.loginForm)
                        .then(() => {
                            this.$router.push({ path: this.redirect || "/" });
                            this.loading = false;
                            this.loading = false;
                        })
                        .catch(() => {
                            //console.log("BAAAAAAAD");
                            this.$message({
                                type: "error",
                                message:
                                    "Votre mot de passe ne semble pas correct",
                                duration: 3 * 1000
                            });
                            this.loading = false;
                        });
                } else {
                    //console.log("BAAAAAAAD");
                    return false;
                }
            });
        }
    }
};
</script>
